'use strict';
import {initSlotCarousel, initializeTooltips} from '../productTileComponent/productTile';
import {lockScroll, unlockScroll, getCookie} from '../util/common';

let debounce = require('lodash/debounce');
let minChars = 3;

export default initSearchComponent;

/**
 * javascript class for jQuery selector
 */
const JS_ELEM = {
    closeModal: '.js-site-search-closeModal',
    inputResetButton: '.js-site-search-clearButton',
    inputSearch: '.js-site-search-inputSearch',
    productBlock: '.js-site-search-suggestions-products',
    searchButtonHeader: '.js-mainHeader-search',
    searchModal: '.js-site-search',
    suggestionPlaceholder: '.js-site-search-suggestions',
    tileProductContainer: '.js-site-search-suggestions-products-itemContainer',
    updateCatSelectionCookieTrigger: '.js-site-search-suggestions a',
    intMenuSvgIconClose: '.js-intMenu-svgIcon_close'
};

/**
 * style class using in add or remove
 */
const CC_ELEM = {
    searchModal_isOpen: 'cc-site-search_open',
    mobileSearchIcon: '.cc-mobile-search-icon'
};

const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,7}\b/;

// Function to check if the string contains an email pattern
function containsEmail (searchString) {
    return emailPattern.test(searchString);
}

function validateInput (event) {
    if (event.key === 'Enter') {
        let isEmail = containsEmail($(JS_ELEM.inputSearch).val());
        if (isEmail) {
            event.preventDefault();
        }
    }
}

function initSearchComponent () {
    $(document.body).on('click', JS_ELEM.searchButtonHeader, openSearchModal);
}

function openSearchModal () {
    $('body').addClass('search-is-open');
    lockScroll();
    addEventSearchModal();
    getSuggestions($(JS_ELEM.inputSearch).val());
    updateIconInSearch();
    $(JS_ELEM.searchModal).fadeIn(1).addClass(CC_ELEM.searchModal_isOpen);
    $(JS_ELEM.inputSearch).trigger('focus');
}

function addEventSearchModal() {
    $(JS_ELEM.searchModal).on('click', JS_ELEM.closeModal, closeSearchModal);
    $(JS_ELEM.searchModal).on('click', JS_ELEM.updateCatSelectionCookieTrigger, selectMainCategory);
    $(JS_ELEM.searchModal).on('mousedown touchstart', JS_ELEM.inputResetButton, clearAllInput);
    $(JS_ELEM.searchModal).on('keydown', JS_ELEM.inputSearch, validateInput);

    var debounceSuggestions = debounce(prepareGetSuggestion, 500);
    $(JS_ELEM.searchModal).on('keyup', JS_ELEM.inputSearch, function (e) {
        $(JS_ELEM.inputResetButton).attr('disabled', $(this).val() < 1);

        if (e.key !== 'Escape') {
            debounceSuggestions(this, e);
        }
    });
}

function removeEventSearchModal() {
    $(JS_ELEM.searchModal).off();
}

function closeSearchModal() {
    unlockScroll();
    $('body').removeClass('search-is-open');
    $(JS_ELEM.searchModal)
        .removeClass(CC_ELEM.searchModal_isOpen)
        .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            $(JS_ELEM.searchModal).hide();
            removeEventSearchModal();
        });
}

function selectMainCategory() {
    const alternativeCategory = $(JS_ELEM.suggestionPlaceholder).data('alternative-category');
    const catSelectionCookie = getCookie('catSelection');
    if (
        alternativeCategory &&
        alternativeCategory.length > 0 &&
        catSelectionCookie !== alternativeCategory
    ) {
        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 500);
        var expiryDate = currentDate.toUTCString();

        document.cookie = 'catSelection=' + alternativeCategory + ';path=/;expires=' + expiryDate;
    }
}

function getSuggestions (q = '') {
    if (containsEmail(q)) {
        return;
    }
    // Recent suggestions should be retrieved if there are no search terms and if the user is registered. Since recent suggestions should not be cached, it is necessary to invoke a different controller
    const suggestionsUrl =
        q === '' && $(JS_ELEM.searchModal).data('isLogged') === true
            ? $(JS_ELEM.searchModal).data('recentSuggestionsUrl')
            : $(JS_ELEM.searchModal).data('suggestionsUrl') + q;

    genericAjaxCall(suggestionsUrl).then(function (newDom) {
        if (newDom) {
            $(JS_ELEM.suggestionPlaceholder).replaceWith(newDom);
            initSlotCarousel(JS_ELEM.productBlock);

            if (!Foundation.MediaQuery.atLeast('large')) {
                $(JS_ELEM.tileProductContainer).slick({
                    arrows: false,
                    autoplay: false,
                    dots: false,
                    infinite: true,
                    slide: '.js-prodTile',
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    variableWidth: true,
                });
            }
            // Analytics event trigger
            $('body').trigger('analytics:productsSuggestions', {
                associatedClass: JS_ELEM.tileProductContainer,
                listType: 'search',
            });
            initializeTooltips();
        }
    });
}

function prepareGetSuggestion(input) {
    let inputValue = $(input).val();
    if (inputValue.length === 0 || inputValue.length >= minChars) {
        getSuggestions(inputValue);
    }
}

function clearAllInput (event) {
    if (event) {
        event.preventDefault();
    }
    $(JS_ELEM.inputSearch).val('');
    $(JS_ELEM.inputSearch).trigger('blur');
    selectMainCategory();
    getSuggestions();
    // event for analytics
    $('body').trigger('search:clearInput');
}

function genericAjaxCall(url, method = 'GET') {
    if (!url) {
        console.error('Missing Url in ajax call');
        return;
    }
    $.spinner().start();
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            method: method,
            success: function (response) {
                $.spinner().stop();
                resolve($(response).clone());
            },
            error: function (error) {
                $.spinner().stop();
                console.error(error);
                reject(error);
            },
        });
    });
}

function updateIconInSearch () {
    $(JS_ELEM.inputSearch).on('focus', function () {
        $(JS_ELEM.intMenuSvgIconClose).removeClass('hide');
        $(CC_ELEM.mobileSearchIcon).addClass('hide');
    });

    $(JS_ELEM.inputSearch).on('blur', function () {
        $(JS_ELEM.intMenuSvgIconClose).addClass('hide');
        $(CC_ELEM.mobileSearchIcon).removeClass('hide');
    });
}
